import { render } from "./AppAlert.vue?vue&type=template&id=61a368c3"
import script from "./AppAlert.vue?vue&type=script&lang=ts"
export * from "./AppAlert.vue?vue&type=script&lang=ts"
script.render = render

export default script